/* eslint-disable import/prefer-default-export */

import { USERS } from 'src/store/ActionTypes';

export const fetchUsers = (query) => ({
  type: USERS.FETCH_USERS,
  payload: query,
});

export const addUser = (user) => ({
  type: USERS.ADD_USER,
  payload: user,
});

export const editUser = (userId, user) => ({
  type: USERS.EDIT_USER,
  payload: {
    userId,
    user,
  },
});

export const deactivateUser = (userId) => ({
  type: USERS.DEACTIVATE_USER,
  payload: userId,
});

export const activateUser = (userId) => ({
  type: USERS.ACTIVATE_USER,
  payload: userId,
});
